let _lastQuickViewTrigger = null;
let _activeQuickViewHandle = null;

function closeQuickView(fromPopstate = false) {
  _activeQuickViewHandle = null;
  const wrapper = document.getElementById("quickViewWrapper");
  if (wrapper) {
    wrapper.classList.remove("show__modal");
    wrapper.innerHTML = "";
  }
  document.body.classList.remove("overflow-hidden");

  const activeElements = document.querySelectorAll(
    ".cart--icon-button.active, button.product__quick_view.active, quick-view-modal button.active, .product__card.active, .product__card.loading"
  );
  activeElements.forEach((el) => {
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(el);
    }
    el.classList.remove("active", "loading");
  });

  if (_lastQuickViewTrigger && typeof _lastQuickViewTrigger.focus === "function") {
    _lastQuickViewTrigger.focus();
    _lastQuickViewTrigger = null;
  }

  if (!fromPopstate && window.history.state?.quickViewOpen) {
    window.history.back();
  }
}

async function openQuickView(productHandle, triggerEl = null) {
  if (!productHandle) return;
  const wrapper = document.getElementById("quickViewWrapper");
  if (!wrapper) return;

  _lastQuickViewTrigger = triggerEl;
  _activeQuickViewHandle = productHandle;
  if (triggerEl) triggerEl.classList.add("loading");

  try {
    const response = await fetch(`/products/${productHandle}?view=quickview`);
    if (!response.ok) {
      throw new Error(`Failed to load quick view: ${response.status}`);
    }
    const resText = await response.text();

    // Guard against race condition if another product was opened in the meantime
    if (_activeQuickViewHandle !== productHandle) return;

    wrapper.innerHTML = resText;

    document.body.classList.add("overflow-hidden");
    wrapper.classList.add("show__modal");
    if (triggerEl) triggerEl.classList.add("active");

    if (!window.history.state?.quickViewOpen) {
      window.history.pushState({ quickViewOpen: true }, "", window.location.href);
    }
  } catch (error) {
    console.error("QuickView error:", error);
    // If modal fetch fails and trigger was a link, fallback to direct page navigation
    if (triggerEl) {
      const link = triggerEl.matches("a") ? triggerEl : triggerEl.querySelector('a[href*="/products/"]');
      if (link && link.href) {
        window.location.href = link.href;
      }
    }
  } finally {
    if (triggerEl) triggerEl.classList.remove("loading");
    if (typeof trapFocus === "function") {
      trapFocus(wrapper);
    }
  }
}

window.openQuickView = openQuickView;
window.closeQuickView = closeQuickView;

// Global modal close handlers
document.addEventListener("keyup", (evt) => {
  if (evt.code === "Escape") {
    const wrapper = document.getElementById("quickViewWrapper");
    if (wrapper && wrapper.classList.contains("show__modal")) {
      closeQuickView();
    }
  }
});

document.addEventListener("click", (event) => {
  const wrapper = document.getElementById("quickViewWrapper");
  if (!wrapper || !wrapper.classList.contains("show__modal")) return;
  // If click was inside modal body or on the opening trigger button, do not close
  if (event.target.closest(".quick_view__body") || event.target.closest("quick-view-modal")) return;
  closeQuickView();
});

window.addEventListener("popstate", () => {
  const wrapper = document.getElementById("quickViewWrapper");
  if (wrapper && wrapper.classList.contains("show__modal")) {
    closeQuickView(true);
  }
});

class quickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);
  }

  onClickQuickViewModal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const quickViewBtn = this.querySelector("button");
    if (!quickViewBtn) return;
    const productHandle = quickViewBtn.dataset.productHandle;
    if (!productHandle) return;
    openQuickView(productHandle, quickViewBtn);
  };
}
if (!customElements.get("quick-view-modal")) {
  customElements.define("quick-view-modal", quickViewModal);
}

class quickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.quickViewClose);
  }

  quickViewClose() {
    closeQuickView();
  }
}
if (!customElements.get("quick-view-close")) {
  customElements.define("quick-view-close", quickViewCloseTag);
}

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).forEach(
      (select, index) => {
        const target = select.children?.[0]?.children?.[1];
        if (target && this.options[index] !== undefined) {
          target.textContent = this.options[index];
        }
      }
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData || !Array.isArray(variantData)) return;

    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const mainImg = document.getElementById(`QuickViewMainImage-${this.dataset.section}`);
    if (mainImg && this.currentVariant.featured_image?.src) {
      mainImg.src = this.currentVariant.featured_image.src;
    }
  }

  updateVariantInput() {
    if (!this.currentVariant) return;
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("no-js-inline");

        const soldOutText = window.variantStrings?.soldOut || "Sold out";
        this.toggleAddButton(
          !this.currentVariant.available,
          soldOutText
        );
      })
      .catch((err) => {
        console.error("Error updating quickview variant info:", err);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    const btnTextEl = addButton.querySelector(".ssps-btn-state--ready .ssps-btn-text") || addButton.querySelector(".ssps-btn-text") || addButton;
    const addToCartText = window.variantStrings?.addToCart || "Add to cart";
    const soldOutText = window.variantStrings?.soldOut || "Sold out";
    const preorderText = window.variantStrings?.preorder || "Pre-order";

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) btnTextEl.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      btnTextEl.textContent = addToCartText;
    }

    // Preorder check
    const productVarArray = this.PreorderVariantData;
    const variant = this.currentVariant;
    const VarInventoryManagement = variant?.inventory_management ?? null;

    if (VarInventoryManagement != null && productVarArray && variant) {
      for (let variant_id in productVarArray) {
        if (variant.id == variant_id) {
          const inventoryQuantity = parseInt(productVarArray[variant_id].qty, 10);
          const inventoryPolicy = productVarArray[variant_id].inventory_policy;

          if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
            addButton.removeAttribute("disabled");
            btnTextEl.textContent = preorderText;
          } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
            addButton.setAttribute("disabled", true);
            btnTextEl.textContent = soldOutText;
          } else {
            addButton.removeAttribute("disabled");
            btnTextEl.textContent = addToCartText;
          }
        }
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (addButton) {
      const btnTextEl = addButton.querySelector(".ssps-btn-state--ready .ssps-btn-text") || addButton;
      btnTextEl.textContent = window.variantStrings?.unavailable || "Unavailable";
      addButton.setAttribute("disabled", true);
    }
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    if (!this.variantData) {
      const el = this.querySelector("[data-variant]");
      if (el && el.textContent) {
        try {
          this.variantData = JSON.parse(el.textContent);
        } catch (e) {
          this.variantData = [];
        }
      } else {
        this.variantData = [];
      }
    }
    return this.variantData;
  }

  getPreOrderVariantData() {
    if (!this.PreorderVariantData) {
      const el = this.querySelector("[data-preorder]");
      if (el && el.textContent) {
        try {
          this.PreorderVariantData = JSON.parse(el.textContent);
        } catch (e) {
          this.PreorderVariantData = {};
        }
      } else {
        this.PreorderVariantData = {};
      }
    }
    return this.PreorderVariantData;
  }
}
if (!customElements.get("quick-variant-selects")) {
  customElements.define("quick-variant-selects", QuickVariantSelects);
}

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const variantData = this.getVariantData();
    if (!variantData || !Array.isArray(variantData)) return;

    const result = Object.values(
      variantData.reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );
    swatchButtonList.forEach((button) => {
      result.forEach((data) => {
        if (data[this.dataset.colorSwatch] === button.dataset.value) {
          if (
            this.dataset.colorSwatchStyle === "image" &&
            data.featured_image !== null &&
            data.featured_image?.src
          ) {
            button.setAttribute(
              "style",
              `--swatch-background-image: url(${
                data.featured_image.src
              }); --swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          } else {
            button.setAttribute(
              "style",
              `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          }
        }
      });
    });
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checked ? checked.value : "";
    });
  }

  updateOptionsParent() {
    this.fieldsets.forEach((fieldset, index) => {
      const target = fieldset.children?.[0]?.children?.[1];
      if (target && this.options[index] !== undefined) {
        target.textContent = this.options[index];
      }
    });
  }
}
if (!customElements.get("quick-variant-radios")) {
  customElements.define("quick-variant-radios", QuickVariantRadios);
}
